import { TextProps } from '@chakra-ui/react'
import { BodyBackgroundNuance, useColor } from '../../theme'

export const useAuthLabelStyle = (): TextProps => {
  const labelBackgroundColor = useColor({
    nuance: BodyBackgroundNuance.Clean,
    palette: 'body',
  })
  const labelColor = useColor({
    nuance: 2,
    palette: 'text',
  })

  return {
    backgroundColor: labelBackgroundColor,
    color: labelColor,
    marginLeft: 2,
    paddingX: 2,
    paddingY: 1,
    position: 'absolute',
    top: -3,
    zIndex: 'overlay',
  }
}
